export const SUPPORTED_DATA_TYPES = new Set([
    'QuickActionBarItem',
    'BasicMenuItem',
    'ImageButton',
    'SubscribeForm',
    'ContactForm',
    'DynamicContactForm',
    'GeoMapLocation',
    'LinkableFlashComponent',
    'LinkableButton',
    'StyledTextLinkHelper',
    'SvgShape',
    'VectorImage',
    'RssButton',
    'wixui.Logo',
    'CollapsibleTextData',
    'ImageX',
    'Image',
    'SelectionTag',
    'StylableButton',
    'TextFxData',
    'dsgnsys.ControlTypes',
    'dsgnsys.DashboardButton',
    'dsgnsys.DashboardIconButton',
    'dsgnsys.DashboardTextButton',
    'dsgnsys.WbuRichText'
])
